module.exports = __webpack_public_path__ + "img/geofisica_4-3.a93592dd.jpg";